module.exports = __webpack_public_path__ + "img/p6.44915e00.png";